<template>
  <div style="min-height: 15vh; margin: auto;padding-bottom: 4vh;">
      <el-row style="padding-bottom: 25px;">
          <el-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24" style="line-height:40px;height:40px;margin-bottom:10px;background-color:#042340;text-align: center;">{{deviceInfo.name}}</el-col>
      </el-row>
    <el-row style="">
      <el-col :xl="7" :lg="7" :md="7" :sm="7" :xs="7" style="text-align: right;margin-right: 10px;">设备名称：</el-col>
      <el-col :xl="15" :lg="15" :md="15" :sm="15" :xs="15">
        <el-input class="inline-input" placeholder="请输入告警名称" size="mini"
                  style="width: 80%" v-model="form.name" v-on:input="change"></el-input>
      </el-col>
    </el-row>
    <el-row style="margin-top: 20px;">
      <el-col :xl="7" :lg="7" :md="7" :sm="7" :xs="7" style="text-align: right;margin-right: 10px;">备注：</el-col>
      <el-col :xl="15" :lg="15" :md="15" :sm="15" :xs="15">
        <el-input
            :rows="4"
            class="inline-input"
            placeholder="请输入内容"
            style="width: 80%"
            type="textarea"
            v-model="form.note"
            v-on:input="change">
        </el-input>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "Modify",
  props: {
    deviceInfo: {},
  },
  data() {
    return {
      form: {
        name: this.deviceInfo.name,
        note: this.deviceInfo.note
      }
    }
  },
  mounted() {
    this.change()
  },
  methods: {
    change() {
      this.$emit("receiveData", this.form)
    }
  },
}
</script>

<style scoped>

</style>
